module.exports = __webpack_public_path__ + "img/2smartphones.88eae60d.svg";